import axios from '../../axios'

export default {
	state: {
		messages: {},
		status: 'ready', // loading, ready, error
		display: false,
		payload: {},
		idChat: 0,
		chatMode: '', // client, author
		collocutor: {},
		disabled: false,
	},
	mutations: {
		updatePayload(state, payload) {
			state.payload = payload;
		},
		updateMessages(state, messages) {
			state.status = 'ready';
			state.messages = messages;
		},
		addMessage(state, message) {
			state.messages.unshift(message);
		},
		messageRequest(state) {
			state.status = 'loading'
		},
		error(state) {
			state.status = 'error';
		},
		showChat(state) {
			if(state.display !== true) {
				state.display = true;
			}
		},
		setIdChat(state,id) {
			state.idChat = id
		},
		makeDisabled(state) {
			state.disabled = true;
		},
		makeAvailable(state) {
			state.disabled = false;
		},
		hideChat(state) {
			state.display = false;
		},
		resetChat(state) {
			state.messages = {};
			state.status = 'ready'; // loading, ready, error
			state.payload = {};
			// state.idChat = 0;
			state.chatMode = ''; // client, author
			state.collocutor = {};
			state.disabled = false;
		},
		updateCollocutor(state, payload) {
			state.collocutor = payload;
		}
	},
	actions: {
		async openChat({commit, dispatch}, payload = null) {
			await dispatch('hideChat');
			await dispatch('getMessages', payload);
		},
		async getMessages({state, commit, rootState},payload = null) {
			commit('messageRequest');

			if(payload && payload.disabled !== null && payload.disabled !== undefined) {
				if(payload.disabled) {
					commit('makeDisabled');
				} else {
					commit('makeAvailable');
				}
			}

			if(payload !== null) {
				if(payload.authorChatId === undefined) {
					this.chatMode = 'client';
				} else {
					this.chatMode = 'author';
				}

				let id;

				if(payload && payload.id){
					id = (await axios.post('/chat/create',{order_id:+payload.id})).data.data.id;
				} else if(payload && payload.userId){
					const res = (await axios.post('/chat/create',{user_id:+payload.userId})).data.data;
					id = res.id;

					let clientData = res.client_data;
					clientData.role = "client";

					commit("updateCollocutor", clientData);
				} else if(payload.authorChatId !== undefined) {
					id = payload.authorChatId;

					if(rootState.auth.role === 'author') {
						commit("updateCollocutor", { role: "order", orderId: payload.orderId });
					} else {
						commit("updateCollocutor", { role: "author", orderId: payload.orderId });
					}
				} else{
					id = (await axios.post('/chat/create')).data.data.id;
					let clientData = { role: "manager" };
					commit("updateCollocutor", clientData);
				}

				commit("setIdChat", id);

				commit('showChat');
			}

			if(payload === null) {
				if(state.display !== false) {
					payload = state.payload;
				} else {
					return;
				}
			} else {
				commit("updatePayload", payload);
			}
			let id = state.idChat;

			if (!id) return false;

			try {
				await axios.post(`/chat/set-messages-viewed/${id}`);
			} catch {

			}

			commit('setIdChat',id)

			try {
				let resp;
				if(this.chatMode === 'client') {
					resp = await axios.get('/chat/view/'+id);
				} else {
					resp = await axios.get('/chat/view-author/'+id);
				}
				commit('updateMessages', resp.data.data);

				return resp;

			} catch(err) {
				commit('error')
				throw new Error(err);
			}
		},
		hideChat({commit}) {
			commit('resetChat');
			commit('hideChat');
		},
		async sendMessage({commit,state,dispatch}, message) {
			commit('messageRequest');
			if(!state.idChat) return false;

			try {
				const url = this.chatMode === 'client'
					? '/chat/send-message/'
					: '/chat/send-message-author/';

				return axios.post(url+state.idChat,{message: message.msg, sendViaEsputnik: message.sendViaEsputnik});

			} catch (err) {
				commit('error');
				throw new Error(err);
			}
		}
	},
	getters: {}
}
